import AuthLayout from '../components/AuthLayout';

const NotFoundPage = () => (
  <AuthLayout
    title="Page Not Found"
    subtitle="The page you're looking for doesn't exist."
  >
    <div className="text-center">
      <p className="text-medium mb-6">
        For login and registration, please use the Pool Guy mobile app.
      </p>
      <a
        href="/"
        className="inline-flex items-center px-4 py-2 bg-primary text-white rounded-lg hover:bg-secondary transition-colors"
      >
        Return Home
      </a>
    </div>
  </AuthLayout>
);

export default NotFoundPage;
